import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 400);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    if (!show) return null;
    return (
        <button
            aria-label="Back to top"
            data-testid="back-to-top-btn"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-6 left-6 z-40 rounded-full bg-brand-blue p-3 text-white shadow-lg transition-colors hover:bg-brand-blue-dark"
        >
            <ArrowUp size={18} />
        </button>
    );
};

export default BackToTop;
